import { useContext } from 'react'
import { GrUndo } from 'react-icons/gr'
import { Icon, HStack } from '@chakra-ui/react'
import { CanvasDrawContext } from './CanvasDrawF'
import { ChooseColorBar } from './ChooseColorBarF'
import { ChooseCursorSize } from './ChooseCursorSizeF'
import { isLightColor } from './ChooseColorBarF'

export const DrawControls = () => {
  const {undoDraw, activeColor} = useContext(CanvasDrawContext)

  const bg = isLightColor(activeColor) ? 'black' : 'white'
  const color = isLightColor(activeColor) ? 'white' : 'black'

  return <>
    <HStack {...{py: 2, fontSize: '30px', justifyContent: 'space-evenly', bg, borderTop: '2px solid black', width: '100%'}}>
      <ChooseCursorSize />
      <Icon {...{as: GrUndo, onClick: undoDraw, color}} />
    </HStack>
    <ChooseColorBar />
  </>
}